export const Config = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT as string,
};
